import {
    get_axios_instance,
    api_variables,
    errorHandler
} from "@/apis/variables.js";
import Vue from "vue";

var axios_instance = get_axios_instance(api_variables.SERVICE_PAYGROUP);

const _pk_name = "id";

const state = {
    data: {},
    showDefaultPaygroupPopup: true,
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    record: {}
};

const getters = {
    editMode: state => {
        return state.editMode;
    },
    record: state => {
        return state.record;
    }
};

const mutations = {
    set: (state, [payload, id]) => {
        Vue.set(state.data, id, payload);
    },

    addEntity: (state, [payload, id]) => {
        if (!state.data[id]) {
            Vue.set(state.data, id, []);
        }
        state.data[id].push(payload);
    },

    updateEntityById: (state, [payload, id]) => {
        for (let i = 0; i < state.data[id].length; i++) {
            if (state.data[id][i][_pk_name] === payload.id) {
                state.data[id].splice(i, 1, payload);
            }
        }
    },

    removeEntityById: (state, [payload, id]) => {
        for (let i = 0; i < state.data[id].length; i++) {
            if (state.data[id][i][_pk_name] == payload) {
                state.data[id].splice(i, 1);
            }
        }
        if (state.data[id].length == 0) state.data = {};
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },
    setEditMode: (state, payload) => {
        state.editMode = payload.editMode;
        state.record = payload.record;
    },

    setShowDefaultPaygroupPopup: (state, payload) => {
        state.showDefaultPaygroupPopup = false;
    }
};

const actions = {
    async fetchAll({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance.get(`/`, {
                params: {
                    le_id: payload
                }
            });
            commit("setFetching", false);
            if (res.status == 200) {
                if (res.data.payload.data.length != 0)
                    commit("set", [res.data.payload.data, payload]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async create({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.post("/", payload);
            commit("setSaving", false);
            if (res.status == 200 || res.status == 201) {
                commit("addEntity", [res.data.payload, payload.le_id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async update({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.put(`/${payload.data.id}`, payload);
            commit("setSaving", false);
            if (res.status == 200) {
                commit("updateEntityById", [res.data.payload, payload.data.le_id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async delete({ commit }, [payload, id]) {
        try {
            commit("setDeleting", true);
            let res = await axios_instance.delete(`/${payload.id}`);
            commit("setDeleting", false);
            if (res.status == 200) {
                commit("removeEntityById", [payload.id, id]);
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async changeEditMode({ commit }, payload) {
        try {
            commit("setEditMode", payload);
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async showPopup({ commit }, payload) {
        try {
            commit("setShowDefaultPaygroupPopup", payload);
        } catch (error) {
            throw errorHandler(error.response);
        }
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};